import X from 'lucide-react/dist/esm/icons/x.js';
import Facebook from 'lucide-react/dist/esm/icons/facebook.js';
import Linkedin from 'lucide-react/dist/esm/icons/linkedin.js';

export default function ShareModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const handleShare = (platform) => {
    const url = window.location.href;
    const text = 'Check out this raffle draw!';

    let shareUrl = '';

    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      case 'x':
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        break;
      default:
        return;
    }

    window.open(shareUrl, '_blank', 'width=600,height=400');
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full p-8 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          aria-label="Close modal"
        >
          <X className="w-6 h-6 text-gray-400" />
        </button>

        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            Help by sharing
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            Fundraisers shared on social networks raise up to 3x more
          </p>
        </div>

        <div className="flex justify-center gap-6 mb-8">
          <button
            onClick={() => handleShare('facebook')}
            className="flex flex-col items-center gap-2 group"
          >
            <div className="w-16 h-16 bg-[#1877F2] rounded-xl flex items-center justify-center transition-transform group-hover:scale-110">
              <Facebook className="w-8 h-8 text-white fill-current" />
            </div>
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Facebook
            </span>
          </button>

          <button
            onClick={() => handleShare('x')}
            className="flex flex-col items-center gap-2 group"
          >
            <div className="w-16 h-16 bg-black rounded-xl flex items-center justify-center transition-transform group-hover:scale-110">
              <svg
                viewBox="0 0 24 24"
                className="w-8 h-8 text-white fill-current"
                aria-hidden="true"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </div>
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              X
            </span>
          </button>

          <button
            onClick={() => handleShare('linkedin')}
            className="flex flex-col items-center gap-2 group"
          >
            <div className="w-16 h-16 bg-[#0A66C2] rounded-xl flex items-center justify-center transition-transform group-hover:scale-110">
              <Linkedin className="w-8 h-8 text-white fill-current" />
            </div>
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              LinkedIn
            </span>
          </button>
        </div>

        <div className="text-center pt-6 border-t border-gray-200 dark:border-gray-700">
          <p className="text-gray-600 dark:text-gray-400">
            Thanks for your support
          </p>
        </div>
      </div>
    </div>
  );
}
